import { endpoints } from '@/services/endpoints';
import { axiosGetRequest } from '@/services/Request';
import { useQuery } from '@tanstack/react-query';
import { AppCard } from '@/components/ui/AppCard';
import { AppBarChart } from '@/components/charts/pieChart/AppBarChart';

export default function TicketsChartsByCommonReason() {
  const { data: ticketsByCommonReason, isLoading } = useQuery({
    queryKey: ['ticketsByCommonReason'],
    queryFn: () => axiosGetRequest(endpoints.getTicketsByCommonReason),
    select: ticketsByCommonReason => ticketsByCommonReason.data,
  });
  const config = {
    count: {
      label: 'Total Count',
      color: '#0D9373',
    },
    Nudity: {
      label: 'Nudity',
      color: '#F59E0B',
    },
    Violence: {
      label: 'Violence',
      color: '#EF4444',
    },
    Spam: {
      label: 'Spam',
      color: '#3B82F6',
    },
    Scam: {
      label: 'Scam',
      color: '#8B5CF6',
    },
    Other: {
      label: 'Other',
      color: '#64748B',
    },
  };

  return (
    <AppCard>
      <h5 className="mb-4 text-base font-semibold text-coal-900">Common Report Reasons</h5>
      <AppBarChart
        chartData={ticketsByCommonReason}
        dataKey="count"
        nameKey="reason"
        config={config}
        isLoading={isLoading}
      />
    </AppCard>
  );
}
